<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js' 
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
			};
		},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			showpz: { 
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {},
		methods: {
			inputblur(e){
			this.$emit("inputblur",e)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			forpz() {
				if (this.showpz) {
					this.$emit("forpz", "")
				}
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 7,
							colspan: 1
						};
					} else if (rowIndex === 7) {
						return {
							rowspan: 11,
							colspan: 1
						};
					} else if (rowIndex === 18) {
						return {
							rowspan: 2,
							colspan: 1
						};
					} else if (rowIndex === 20) {
						return {
							rowspan: 2,
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
				if (columnIndex === 1) {
					if (rowIndex === 0) {
						return {
							rowspan: 5,
							colspan: 1
						};
					} else if (rowIndex === 5) {
						return {
							rowspan: 2,
							colspan: 1
						};
					} else if (rowIndex === 7) {
						return {
							rowspan: 9,
							colspan: 1
						};
					} else if (rowIndex === 16) {
						return {
							rowspan: 2,
							colspan: 1
						};
					} else if ([18, 19, 20, 21].includes(rowIndex)) {
						return {
							rowspan: 1,
							colspan: 2
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
				if (columnIndex === 2) {
					if ([18, 19, 20, 21].includes(rowIndex)) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			},
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SalesTaxReport/index.less');
</style>
